import React from 'react'
import { EventType } from 'types/NewsItem'

function NewsHeadlineProspectusMemorandum({ row }: { row: { companyName: string; eventType: EventType } }) {
    const { companyName, eventType } = row

    return (
        <span>
            {companyName}{' '}
            {eventType === 'prospectus'
                ? 'prospekt'
                : eventType === 'informationdocument'
                  ? 'informationsdokument'
                  : eventType}{' '}
            finns nu tillgängligt
        </span>
    )
}

export default NewsHeadlineProspectusMemorandum
